export function getAdminToken() {
  return localStorage.getItem('admin_token') || '';
}

export async function adminFetch(url, options = {}) {
  const token = getAdminToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(url, { ...options, headers });
  return res;
}

export function storeAdminToken(token) {
  if (token) localStorage.setItem('admin_token', token);
}

/** Upload an image to Cloudinary via admin API. Returns secure URL. */
export async function uploadAdminImage(file, folder = 'seo') {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('folder', folder);
  const res = await adminFetch('/api/upload/image', { method: 'POST', body: formData });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Image upload failed.');
  }
  return data.url;
}
